import { DetailedHTMLProps, forwardRef, InputHTMLAttributes, Ref } from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import SearchIcon from '~/components/atoms/Icons/SearchIcon';
import XIcon from '~/components/atoms/Icons/XIcon';

import styles from './SearchInput.module.scss';

interface ISearchInputProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  onClearIconClick: () => void;
  inputClassName?: string;
}

const SearchInput = forwardRef(
  (
    {
      value,
      className,
      onClearIconClick,
      inputClassName,
      ...props
    }: ISearchInputProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <div
        className={classNames(styles.wrapper, className)}
        ref={ref}
      >
        <SearchIcon
          background={false}
          className={styles.search}
        />
        <input
          className={classNames(styles.input, inputClassName)}
          value={value}
          type="text"
          placeholder={I18n.t('CardListView_searchbar_placeholder')}
          {...props}
        />
        {Boolean(value) && (
          <XIcon
            onClick={onClearIconClick}
            className={styles.clear}
            background={false}
          />
        )}
      </div>
    );
  },
);

SearchInput.displayName = 'SearchInput';

export default SearchInput;
